
document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-mobile-toggle]');
  const menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu){
    toggle.addEventListener('click',()=>{
      const open=menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded',open?'true':'false');
    });
  }
});

/* ArcanaCCG V9 premium storefront features */
document.addEventListener('DOMContentLoaded', () => {
  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);

  document.querySelectorAll('[data-smart-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = [...carousel.querySelectorAll('.smart-featured__slide')];
    if (!viewport || !track || slides.length === 0) return;
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const progress = carousel.querySelector('[data-carousel-progress]');
    const dotsWrap = carousel.querySelector('[data-carousel-dots]');
    const loop = carousel.dataset.loop === 'true';
    const autoplay = carousel.dataset.autoplay === 'true';
    const pauseHover = carousel.dataset.pauseHover === 'true';
    const delay = Math.max(2000, Number(carousel.dataset.delay) || 5000);
    const step = () => (slides[0]?.getBoundingClientRect().width || 260) + 20;
    let timer;
    let dragging = false;
    let startX = 0;
    let startScroll = 0;

    if (dotsWrap) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'carousel-dot';
        dot.setAttribute('aria-label', `Go to product ${i + 1}`);
        dot.addEventListener('click', () => viewport.scrollTo({ left: i * step(), behavior: 'smooth' }));
        dotsWrap.appendChild(dot);
      });
    }

    const update = () => {
      const max = Math.max(1, viewport.scrollWidth - viewport.clientWidth);
      const ratio = Math.min(1, Math.max(0, viewport.scrollLeft / max));
      if (progress) progress.style.width = `${Math.max(5, ratio * 100)}%`;
      if (dotsWrap) {
        const active = Math.min(slides.length - 1, Math.round(viewport.scrollLeft / step()));
        [...dotsWrap.children].forEach((d, i) => d.classList.toggle('is-active', i === active));
      }
    };
    const move = (direction) => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      let target = viewport.scrollLeft + direction * step();
      if (loop && direction > 0 && target >= max - 4) target = 0;
      if (loop && direction < 0 && viewport.scrollLeft <= 4) target = max;
      viewport.scrollTo({ left: target, behavior: 'smooth' });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && slides.length > 1) timer = window.setInterval(() => move(1), delay);
    };

    prev?.addEventListener('click', () => { move(-1); start(); });
    next?.addEventListener('click', () => { move(1); start(); });
    viewport.addEventListener('scroll', update, { passive: true });
    viewport.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        viewport.scrollLeft += e.deltaY;
      }
    }, { passive: false });
    viewport.addEventListener('pointerdown', (e) => {
      dragging = true; startX = e.clientX; startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging'); viewport.setPointerCapture(e.pointerId); stop();
    });
    viewport.addEventListener('pointermove', (e) => {
      if (dragging) viewport.scrollLeft = startScroll - (e.clientX - startX);
    });
    const endDrag = () => { dragging = false; viewport.classList.remove('is-dragging'); start(); };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    if (pauseHover) { carousel.addEventListener('mouseenter', stop); carousel.addEventListener('mouseleave', start); }
    update(); start();
  });

  const wishlistKey = 'arcanaWishlist';
  const getWishlist = () => { try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch { return []; } };
  const paintWishlist = () => {
    const saved = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = saved.includes(button.dataset.handle);
      button.classList.toggle('is-saved', active);
      button.textContent = active ? '♥' : '♡';
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    const handle = button.dataset.handle;
    const saved = getWishlist();
    const updated = saved.includes(handle) ? saved.filter((h) => h !== handle) : [handle, ...saved].slice(0, 50);
    localStorage.setItem(wishlistKey, JSON.stringify(updated));
    paintWishlist();
  });
  paintWishlist();

  document.querySelectorAll('[data-quick-add-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = form.querySelector('button');
      const original = button.textContent;
      button.disabled = true; button.textContent = 'ADDING…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add item');
        button.textContent = 'ADDED ✓';
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        button.textContent = 'TRY AGAIN';
      } finally {
        window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1600);
      }
    });
  });

  const modal = document.querySelector('[data-quick-view-modal]');
  const modalContent = modal?.querySelector('[data-quick-view-content]');
  const closeModal = () => { if (modal) { modal.hidden = true; document.body.style.overflow = ''; } };
  modal?.querySelectorAll('[data-quick-view-close]').forEach((el) => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
  document.querySelectorAll('[data-quick-view]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (!modal || !modalContent) return;
      modal.hidden = false; document.body.style.overflow = 'hidden';
      modalContent.innerHTML = '<div class="quick-view-loading">Loading product…</div>';
      try {
        const product = await fetch(button.dataset.url, { headers: { 'Accept': 'application/json' } }).then((r) => { if (!r.ok) throw new Error(); return r.json(); });
        const variant = product.variants.find((v) => v.available) || product.variants[0];
        const image = product.featured_image || product.images?.[0] || '';
        const options = product.variants.map((v) => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${v.title} — ${money(v.price)}${v.available ? '' : ' — Sold out'}</option>`).join('');
        const productTags = Array.isArray(product.tags) ? product.tags.map((tag) => String(tag).toLowerCase()) : String(product.tags || '').toLowerCase().split(',');
        const preorderMarkers = ['preorder', 'pre-order', 'pre-sale', 'presale', 'pre-release', 'prerelease'];
        const titleLower = String(product.title || '').toLowerCase();
        const isPreorder = preorderMarkers.some((marker) => productTags.includes(marker) || titleLower.includes(`[${marker}]`));
        const preorderNotice = isPreorder
          ? `<div class="quick-view-preorder-warning"><strong>Preorder cancellation policy</strong><p>Customer-requested cancellations approved before shipment are subject to a 10% cancellation fee, which will be deducted from the refunded amount. This fee helps offset non-refundable payment processing fees and administrative costs incurred when the original transaction is processed.</p></div>`
          : '';
        const preorderProperties = isPreorder
          ? `<input type="hidden" name="properties[Order type]" value="Pre-order"><input type="hidden" name="properties[Cancellation policy]" value="10% cancellation fee for approved customer-requested cancellations before shipment">`
          : '';
        modalContent.innerHTML = `<div class="quick-view-grid"><div>${image ? `<img src="${image}" alt="${product.title.replace(/"/g, '&quot;')}">` : ''}</div><div class="quick-view-info"><p class="eyebrow">${product.vendor || 'ARCANACCG'}</p><h2>${product.title}</h2><div class="quick-view-price">${money(variant?.price || product.price)}</div>${preorderNotice}<form action="/cart/add" method="post" data-quick-view-form><select name="id">${options}</select><input type="hidden" name="quantity" value="1">${preorderProperties}<button class="button" type="submit">${isPreorder ? 'PRE-ORDER NOW' : 'ADD TO CART'}</button></form><a class="button button-secondary" href="${product.url}">VIEW FULL DETAILS</a></div></div>`;
        modalContent.querySelector('[data-quick-view-form]')?.addEventListener('submit', async (e) => {
          e.preventDefault();
          const form = e.currentTarget; const btn = form.querySelector('button'); btn.disabled = true; btn.textContent = 'ADDING…';
          const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
          btn.textContent = r.ok ? 'ADDED ✓' : 'TRY AGAIN';
          if (r.ok) document.dispatchEvent(new CustomEvent('cart:updated'));
        });
      } catch { modalContent.innerHTML = '<div class="quick-view-loading">Unable to load this product. Please open the full product page.</div>'; }
    });
  });

  const currentCard = document.querySelector('[data-current-product-handle]');
  if (currentCard?.dataset.currentProductHandle) {
    const key = 'arcanaRecentlyViewed';
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch {}
    handles = [currentCard.dataset.currentProductHandle, ...handles.filter((h) => h !== currentCard.dataset.currentProductHandle)].slice(0, 12);
    localStorage.setItem(key, JSON.stringify(handles));
  }

  document.querySelectorAll('[data-recently-viewed-section]').forEach(async (section) => {
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('arcanaRecentlyViewed') || '[]'); } catch {}
    const limit = Number(section.dataset.limit) || 8;
    handles = handles.slice(0, limit);
    if (!handles.length) return;
    const track = section.querySelector('[data-recently-viewed-track]');
    const products = (await Promise.all(handles.map((h) => fetch(`/products/${h}.js`).then((r) => r.ok ? r.json() : null).catch(() => null)))).filter(Boolean);
    if (!products.length) return;
    track.innerHTML = products.map((p) => `<div class="smart-featured__slide"><article class="product-card card"><a href="${p.url}"><div class="product-image">${p.featured_image ? `<img loading="lazy" src="${p.featured_image}" alt="${p.title.replace(/"/g, '&quot;')}">` : ''}</div><div class="product-body"><div class="vendor">${p.vendor || 'ARCANACCG'}</div><div class="product-title">${p.title}</div><div class="price">${money(p.price)}</div></div></a></article></div>`).join('');
    section.hidden = false;
  });
});
